<template>
    <button class="hamburger-button">
        <span class="sr-only">{{$t('components.toggle-menu')}}</span>
    </button>
</template>

<script>
    export default {
        name: 'hamburger-button',
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables";

    .hamburger-button {
        position: relative;
        appearance: none;
        padding: 10px 5px;
        margin: 0;
        border: 0;
        background: none;

        &:before,
        &:after {
            content: '';
            height: 2px;
            width: 22px;
            background: @YPS-secondary;
            display: block;
        }

        &:before {
            margin-bottom: 6px;
        }
    }
</style>
